import { Link } from 'react-router-dom';

const latestArticles = [
  {
    id: 'a001',
    title: '冬季户外保暖全攻略：从穿衣到装备的科学指南',
    excerpt: '冬季户外活动时，科学保暖比盲目穿厚更重要。本文为您详细解析三层穿衣法的原理，以及如何选择适合的保暖装备，让您在寒冬中也能舒适自如。',
    category: '使用指南',
    readTime: '8分钟',
    date: '2025-12-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20outdoor%20winter%20hiking%20scene%20with%20warm%20amber%20lighting%20and%20snowy%20mountain%20landscape%2C%20photographer%20style%2C%20soft%20golden%20hour%20light%20on%20snow-covered%20trail%2C%20modern%20outdoor%20lifestyle%20photography%2C%20warm%20tones%20with%20cold%20environment%20contrast%2C%20high%20detail%20composition&width=800&height=500&seq=article-preview-a001&orientation=landscape',
  },
  {
    id: 'a004',
    title: '极寒环境下的保暖科技：从被动保暖到主动发热',
    excerpt: '传统保暖依靠增加衣物厚度，而现代发热科技正在改变这一格局。了解从碳纤维到石墨烯的发热技术演进，以及主动发热装备如何重塑寒冷体验。',
    category: '产品科技',
    readTime: '9分钟',
    date: '2025-10-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=High-tech%20heating%20product%20components%20with%20carbon%20fiber%20and%20modern%20materials%20on%20clean%20warm%20background%2C%20product%20technology%20photography%2C%20soft%20studio%20lighting%20with%20warm%20glow%2C%20innovation%20and%20technology%20aesthetic%2C%20professional%20commercial%20shot&width=800&height=500&seq=article-preview-a004&orientation=landscape',
  },
  {
    id: 'a006',
    title: '老人冬季保暖特别指南：安全、舒适、科学',
    excerpt: '老年人由于新陈代谢减缓，对寒冷更加敏感。本文从医学角度出发，为老年朋友提供一份安全、舒适、科学的冬季保暖方案，让温暖与健康同行。',
    category: '使用指南',
    readTime: '6分钟',
    date: '2025-09-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elderly%20person%20comfortably%20reading%20in%20warm%20cozy%20living%20room%20with%20soft%20natural%20light%2C%20lifestyle%20photography%2C%20peaceful%20winter%20indoor%20scene%2C%20warm%20amber%20tones%20and%20comfortable%20atmosphere%2C%20elegant%20senior%20lifestyle%20composition&width=800&height=500&seq=article-preview-a006&orientation=landscape',
  },
];

export default function ArticlePreview() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2 font-heading">
                <a href="#article-preview">暖身指南</a>
              </h2>
              <p className="text-sm text-foreground-600">科学的保暖知识，让温暖更持久</p>
            </div>
            <Link
              to="/articles"
              className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部文章
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.id}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
              >
                <div className="aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2.5">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}阅读</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 font-heading">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                  <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center justify-between">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{article.date}</span>
                    <span className="text-xs text-primary-600 font-medium flex items-center gap-0.5 whitespace-nowrap">
                      阅读全文
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/articles"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部文章
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}